import { Project } from '@/models/Project';
import { useTranslation } from 'react-i18next';
import { ProjectSectionContainer } from './ProjectSectionContainer';

export const ProjectDocumentation = ({
  documentation,
}: Pick<Project, 'documentation'>) => {
  const { t: tField } = useTranslation('translation', {
    keyPrefix: 'projects.fields',
  });

  return (
    <ProjectSectionContainer title={tField('documentation.label')}>
      <iframe
        src={documentation}
        title={tField('documentation.filename')}
        height={600}
        className="w-full"
      />
    </ProjectSectionContainer>
  );
};
